import { useMemo } from "react";

const useActiveDemeritsColor = company =>
  useMemo(
    () => {
      const demerits = company.demerits;

      if (demerits === 1) {
        return "#4CAF50";
      } else if ([2, 3].includes(demerits)) {
        return "#e9f100";
      } else if (demerits > 3) {
        return "#ea1c0d";
      }

      return "inherit";
    },
    [company]
  );

export default useActiveDemeritsColor;



// WEBPACK FOOTER //
// ./app/hooks/useActiveDemeritsColor.js